import { StyledIcon } from 'src/styles/theme/components/NGIcon/NGIcon.styles';
import { ESize, EThemeColor } from 'src/styles/theme/utils/enums';
import { addMarginStyles, addTransition, getThemeColor } from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';

export const StyledNGSquareButton = styled.button<{
	size?: ESize.s | ESize.m | ESize.l;
	isHidden?: boolean;
	disabled?: boolean;
	containsChildren?: boolean;
	colorVariant?: EThemeColor;
}>`
	${(p) => css`
		position: relative;
		border: none;
		background-color: transparent;
		padding: 0;

		${addTransition()}

		${!p.disabled && !p.isHidden ? `cursor: pointer;` : 'pointer-events: none;'}
		${p.disabled ? `opacity: 0.5;` : ''}
		${p.isHidden ? `opacity: 0;` : ''}

		${addMarginStyles(p)}

		border-radius: 5px;
		border: solid 1px;
		background-color: ${p.theme.colors.carbon};

		border-color: ${getThemeColor(p.theme, p.colorVariant || EThemeColor.gold)}80;

		${p.containsChildren
			? css`
					& > div {
						display: flex;
						justify-content: center;
						align-items: center;

						${() => {
							switch (p.size) {
								case ESize.s:
									return `
							width: 30px;
							height: 30px;
							& ${StyledIcon} {
								font-size: 18px;
							}
							`;
								case ESize.m:
									return `
								width: 40px;
								height: 40px;
								& ${StyledIcon} {
									font-size: 22px;
								}

								`;
								case ESize.l:
									return `
									width: 50px;
									height: 50px;
									& ${StyledIcon} {
										font-size: 30px;
									}
									`;
								default:
									return `
										width: 30px;
										height: 30px;
										& ${StyledIcon} {
											font-size: 30px;
										}
										`;
							}
						}}
					}
			  `
			: css`
					& ${StyledIcon} {
						@media (hover: hover) {
							&:hover {
								opacity: 0.9;
								${p.disabled || p.isHidden ? `opacity: inherit;` : ''}
							}
						}

						${p.disabled ? `opacity: inherit;` : ''}

						${() => {
							switch (p.size) {
								case ESize.s:
									return `
						width: 30px;
						height: 30px;

						font-size: 18px;
						`;
								case ESize.m:
									return `
							width: 34px;
							height: 34px;

							font-size: 20px;

							`;
								case ESize.l:
									return `
								width: 50px;
								height: 50px;

								font-size: 30px;
								`;
								default:
									return `
									width: 30px;
									height: 30px;

									font-size: 30px;
					`;
							}
						}}
					}
			  `}
	`}
`;
